import React from 'react';
import { OptionSelect } from '../../../../../components/UI-Elements/Select/OptionSelect';
import { ToggleNumberInput } from '../../../../../components/UI-Elements/ToogleNumber/ToggleNumberInput';
import { IFutureOrder } from '../../../../../sp-types/FutureOrderType';

const MULTIPLE = 'Multiple';

export interface Props {
  adjustmentOptions: string[];
  saveValues: (_paymentAdj?: string, _supplierAdj?: string, _leadTime?: number) => void;
  editedOrder: IFutureOrder;
  isSupplyAdjustmentMultiValue: boolean;
  isSupplyLeadTimeMultiValue: boolean;
  isDisabled?: boolean;
}
export const FOSummaryInputs: React.FC<Props> = ({
  adjustmentOptions,
  saveValues,
  editedOrder,
  isSupplyAdjustmentMultiValue,
  isSupplyLeadTimeMultiValue,
}) => {
  const firstMaterial = Object.keys(editedOrder.clientExposure)[0];
  const clientAdjustment = editedOrder.clientExposure[firstMaterial]?.adjustment || 'Trailing month';
  const { adjustment, supplyLeadTime } = editedOrder.supplierExposure?.[0] || {};

  const [paymentAdjustment, setPaymentAdjustment] = React.useState<string>(clientAdjustment);
  const [supplierAdjustment, setSupplierAdjustment] = React.useState<string>(adjustment || 'Trailing month');
  const [supplierLeadTime, setSupplierLeadTime] = React.useState<number>(supplyLeadTime || 0);

  React.useEffect(() => {
    if (editedOrder.supplierExposure?.length && editedOrder.clientExposure) {
      const firstMaterial = Object.values(editedOrder.clientExposure)[0];
      const clientAdjustment = firstMaterial?.adjustment || 'Trailing month';

      setPaymentAdjustment(clientAdjustment);
      setSupplierAdjustment(editedOrder.supplierExposure[0].adjustment);
      setSupplierLeadTime(editedOrder.supplierExposure[0].supplyLeadTime);
    }
  }, [editedOrder.supplierExposure, editedOrder.clientExposure]);

  const isEditable = (): boolean => {
    return editedOrder.status === 'completed' ? false : true;
  };

  return (
    <div className="flex gap-20 h-full mx-auto">
      <div className="flex flex-1 px-3 p-2 gap-3 shadow-custom w-80">
        <img className="w-9 h-9 my-auto border-1 border-red" src="/assets/icons/red/client.svg" alt="client"></img>
        <div className="w-full">
          <h6 className="text-gray-700 text-sm opacity-80 font-normal">Order price adjustment</h6>
          <OptionSelect
            showNoneOption={false}
            isEditable={isEditable()}
            currentOption={paymentAdjustment}
            options={adjustmentOptions}
            setCurrentOption={(payAdjustment) => {
              setPaymentAdjustment(payAdjustment);
              saveValues(payAdjustment, undefined, undefined);
            }}
          />
        </div>
      </div>
      <div className="flex flex-1 px-3 p-2 gap-3 shadow-custom w-80">
        <img className="w-9 h-9 my-auto" src="/assets/icons/red/delivery.svg" alt="delivery"></img>
        <div className="space-y-2 flex-1">
          <h6 className="text-gray-700 opacity-80 font-normal text-sm">Supply price adjustment</h6>
          <OptionSelect
            showNoneOption={false}
            isEditable={isEditable()}
            isOptionDisabled={(option) => option === MULTIPLE}
            currentOption={isSupplyAdjustmentMultiValue ? MULTIPLE : supplierAdjustment}
            options={[...adjustmentOptions, MULTIPLE]}
            setCurrentOption={(suppAdjustment) => {
              setSupplierAdjustment(suppAdjustment);
              saveValues(undefined, suppAdjustment, undefined);
            }}
          />
        </div>
      </div>
      <div className="flex flex-1 px-3 p-2 gap-3 shadow-custom w-80">
        <img className="w-9 h-9 my-auto" src="/assets/icons/red/calendar.svg" alt="calendar"></img>
        <div className="space-y-2 flex-1">
          <h6 className="text-gray-700 text-sm opacity-80 font-normal">Supply lead time</h6>
          <ToggleNumberInput
            isEditable={isEditable()}
            valueState={supplierLeadTime}
            setValueState={(suppLeadTime) => {
              setSupplierLeadTime(suppLeadTime);
              saveValues(undefined, undefined, suppLeadTime);
            }}
            downLimit={0}
            upperLimit={11}
            suffix={isSupplyLeadTimeMultiValue ? 'Multiple' : 'm'}
            showOnlySuffix={isSupplyLeadTimeMultiValue}
          />
        </div>
      </div>
    </div>
  );
};
